// on scroll product load code start here

"use strict";var Ajaxinate=function(e){var i=e||{},n={pagination:".AjaxinatePagination",method:"scroll",container:".AjaxinateLoop",offset:0,loadingText:"Loading",callback:null};this.settings=Object.assign(n,i),this.addScrollListeners=this.addScrollListeners.bind(this),this.addClickListener=this.addClickListener.bind(this),this.checkIfPaginationInView=this.checkIfPaginationInView.bind(this),this.stopMultipleClicks=this.stopMultipleClicks.bind(this),this.destroy=this.destroy.bind(this),this.containerElement=document.querySelector(this.settings.container),this.paginationElement=document.querySelector(this.settings.pagination),this.initialize()};Ajaxinate.prototype.initialize=function(){if(this.containerElement){var e={click:this.addClickListener,scroll:this.addScrollListeners};e[this.settings.method]()}},Ajaxinate.prototype.addScrollListeners=function(){this.paginationElement&&(document.addEventListener("scroll",this.checkIfPaginationInView),window.addEventListener("resize",this.checkIfPaginationInView),window.addEventListener("orientationchange",this.checkIfPaginationInView))},Ajaxinate.prototype.addClickListener=function(){this.paginationElement&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.clickActive=!0,this.nextPageLinkElement!==null&&this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks))},Ajaxinate.prototype.stopMultipleClicks=function(e){e.preventDefault(),this.clickActive&&(this.nextPageLinkElement.innerHTML=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.clickActive=!1,this.loadMore())},Ajaxinate.prototype.checkIfPaginationInView=function(){var e=this.paginationElement.getBoundingClientRect().top-this.settings.offset,i=this.paginationElement.getBoundingClientRect().bottom+this.settings.offset;e<=window.innerHeight&&i>=0&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.removeScrollListener(),this.nextPageLinkElement&&(this.nextPageLinkElement.innerHTML=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.loadMore()))},Ajaxinate.prototype.loadMore=function(){this.request=new XMLHttpRequest,this.request.onreadystatechange=function(){if(this.request.readyState===4&&this.request.status===200){var i=this.request.responseXML.querySelectorAll(this.settings.container)[0],n=this.request.responseXML.querySelectorAll(this.settings.pagination)[0];this.containerElement.insertAdjacentHTML("beforeend",i.innerHTML),this.paginationElement.innerHTML=n.innerHTML,this.settings.callback&&typeof this.settings.callback=="function"&&this.settings.callback(this.request.responseXML),this.initialize()}}.bind(this),this.request.open("GET",this.nextPageUrl),this.request.responseType="document",this.request.send()},Ajaxinate.prototype.removeClickListener=function(){this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks)},Ajaxinate.prototype.removeScrollListener=function(){document.removeEventListener("scroll",this.checkIfPaginationInView),window.removeEventListener("resize",this.checkIfPaginationInView),window.removeEventListener("orientationchange",this.checkIfPaginationInView)},Ajaxinate.prototype.destroy=function(){var e={click:this.removeClickListener,scroll:this.removeScrollListener};return e[this.settings.method](),this};

// on scroll product load code end here


// search filter in collection page code start here 

if(document.querySelector('.collection-page')) {

  let textInput = document.getElementById('collection-search');
  let timeout = null;
  textInput.addEventListener('keyup', function (e) {
  clearTimeout(timeout); 
  timeout = setTimeout(function () {
  var test1 = textInput.value;
      let collection_search_handle = $('.collections__list').attr('data-collection-name');     
      let tag_val = [];
      $('input[name=collection-filter]:checked').each(function(i){        
            tag_val[i] = $(this).attr('data-attr-tag');
            
          });
     if(test1.length > 0) {    
     $.ajax({
       type: 'GET',
       url: '/collections/'+collection_search_handle+'?view=ch-all-product-search',
       dataType: 'html',
       success: function(data) { 
         var markup1 =$(data).find('.main-grid-wrapper .collections__box-col');
         var value = test1.toLowerCase();
         var alax = "";
         let prof = "";
              markup1.each(function(i,v) {              
                prof = this;
                var match_array_tag = $(this).find('.collections__box').attr('data-tag');
                var tag_array = match_array_tag.split(",").map(item => item.trim());   
                var match_array_handle = $(this).find('.js-productDetail-modalBtn').attr('data-product-handle');               


              if ( tag_val.length > 0) {
                for (var i = 0; i < tag_val.length; i++) {                          
                  if (tag_array.indexOf(tag_val[i]) > -1 && (($(this).find('.card__heading').text().toLowerCase().includes($("#collection-search").val().toLowerCase()) ) || ($(this).find('.product-description-wrapper').text().toLowerCase().includes($("#collection-search").val().toLowerCase())) || ($(this).find('.product-metafield-wrapper').text().toLowerCase().includes($("#collection-search").val().toLowerCase())) ) ) {                              
                      let mass = $(prof).html()
                      if(alax == ""){
                        alax += `<div class="pure-u-12-24 pure-u-sm-8-24 pure-u-md-6-24 collections__box-col">${mass}</div>`                              
                      }
                      else{
                        var qus = $(alax);                                                                         
                        var isPresent = false;                                                                                                       
                        qus.each(function(i,v) {                                                                                                                                  
                            if($(this).find('.js-productDetail-modalBtn').attr('data-product-handle') == match_array_handle ){
                              isPresent = true;
                            }                           
                        })

                        if(!isPresent) {
                          alax += `<div class="pure-u-12-24 pure-u-sm-8-24 pure-u-md-6-24 collections__box-col">${mass}</div>`  
                        }
                      }                      
                  } 
                  else{
                  }                 
              }
              }else{
                  if(($(this).find('.card__heading').text().toLowerCase().includes($("#collection-search").val().toLowerCase()) ) || ($(this).find('.product-description-wrapper').text().toLowerCase().includes($("#collection-search").val().toLowerCase())) || ($(this).find('.product-metafield-wrapper').text().toLowerCase().includes($("#collection-search").val().toLowerCase())) ){   
                    let mass = $(prof).html()                    
                    alax += `<div class="pure-u-12-24 pure-u-sm-8-24 pure-u-md-6-24 collections__box-col
                    ">${mass}</div>`
                }
              }
           });
           if(alax == ""){  
            $('.main-grid-wrapper').html('<div class="no-product-mathc-collection">Sorry, no products matched your selection</div>');
           }else{
            $('.main-grid-wrapper').html(alax);
            $( ".collections__box-col" ).each(function( index ) {
              $(this).find('.product-metafield-wrapper').remove();
             });
           }
           
  
       }
     })
     }
     else{
      if (!$("input[name=collection-filter]").is(":checked")) {
        $.ajax({
          type: 'GET',
          url: '/collections/'+collection_search_handle+'?view=ch-collection',
          dataType: 'html',
          success: function(data) { 
            var markup =$(data).find('.main-grid-wrapper').html();                       
              $('.main-grid-wrapper').html(markup);         
          }
        })
      }
      else{
            let tag_val = [];
      $('input[name=collection-filter]:checked').each(function(i){        
            tag_val[i] = $(this).attr('data-attr-tag');            
          });
  
          if ( tag_val.length > 0) {
              $.ajax({
                  type: 'GET',
                  url: '/collections/'+collection_search_handle+'?view=ch-all-product-search',
                  dataType: 'html',
                  success: function(data) {  
                    var markup1 =$(data).find('.main-grid-wrapper .collections__box-col');                   
                    var alax = "";
                    let prof = "";
                         markup1.each(function(i,v) {                       
                           prof = this;
                           var match_array_tag = $(this).find('.collections__box').attr('data-tag');
                           var tag_array = match_array_tag.split(",").map(item => item.trim());
                           var match_array_handle = $(this).find('.js-productDetail-modalBtn').attr('data-product-handle');  
   
                           for (var i = 0; i < tag_val.length; i++) {                            
                            if (tag_array.indexOf(tag_val[i]) > -1 && (($(this).find('.card__heading').text().toLowerCase().includes($("#collection-search").val().toLowerCase()) ) || ($(this).find('.product-description-wrapper').text().toLowerCase().includes($("#collection-search").val().toLowerCase())) || ($(this).find('.product-metafield-wrapper').text().toLowerCase().includes($("#collection-search").val().toLowerCase())))) {                              
                                let mass = $(prof).html()
                                if(alax == ""){
                                  alax += `<div class="pure-u-12-24 pure-u-sm-8-24 pure-u-md-6-24 collections__box-col">${mass}</div>`                              
                                }
                                else{
                                  var qus = $(alax);                                                                           
                                  var isPresent = false;                                                                                                       
                                  qus.each(function(i,v) {                                                                                                                                  
                                      if($(this).find('.js-productDetail-modalBtn').attr('data-product-handle') == match_array_handle ){
                                        isPresent = true;
                                      }                           
                                  })
  
                                  if(!isPresent) {
                                    alax += `<div class="pure-u-12-24 pure-u-sm-8-24 pure-u-md-6-24 collections__box-col">${mass}</div>`  
                                  }
                                }                                
                            }
                        }                     
                      });            
                      $('.main-grid-wrapper').html(alax);    
                      $( ".collections__box-col" ).each(function( index ) {
                        $(this).find('.product-metafield-wrapper').remove();
                       });                     
                  }
                })
          }
      }
     }
    }, 1000);
 });




 $(".input_tag_checkbox").change(function(e){    
    let collection_search_handle = $('.collections__list').attr('data-collection-name');
    let tag_val = [];
    $('input[name=collection-filter]:checked').each(function(i){        
          tag_val[i] = $(this).attr('data-attr-tag');          
        });
        if ( tag_val.length > 0) {
            $.ajax({
                type: 'GET',
                url: '/collections/'+collection_search_handle+'?view=ch-all-product-search',
                dataType: 'html',
                success: function(data) {  
                  var markup1 =$(data).find('.main-grid-wrapper .collections__box-col');                                   
                  var alax = "";
                  let prof = "";
                       markup1.each(function(i,v) {                       
                         prof = this;
                         var match_array_tag = $(this).find('.collections__box').attr('data-tag');
                         var tag_array = match_array_tag.split(",").map(item => item.trim());
                         var match_array_handle = $(this).find('.js-productDetail-modalBtn').attr('data-product-handle');  

                        for (var i = 0; i < tag_val.length; i++) {                          
                          if (tag_array.indexOf(tag_val[i]) > -1 && (($(this).find('.card__heading').text().toLowerCase().includes($("#collection-search").val().toLowerCase()) ) || ($(this).find('.product-description-wrapper').text().toLowerCase().includes($("#collection-search").val().toLowerCase())) || ($(this).find('.product-metafield-wrapper').text().toLowerCase().includes($("#collection-search").val().toLowerCase())))) {                              
                              let mass = $(prof).html()
                              if(alax == ""){
                                alax += `<div class="pure-u-12-24 pure-u-sm-8-24 pure-u-md-6-24 collections__box-col">${mass}</div>`                              
                              }
                              else{
                                var qus = $(alax);                                                                         
                                var isPresent = false;                                                                                                       
                                qus.each(function(i,v) {                                                                                                                                  
                                    if($(this).find('.js-productDetail-modalBtn').attr('data-product-handle') == match_array_handle ){
                                      isPresent = true;
                                    }                           
                                })

                                if(!isPresent) {
                                  alax += `<div class="pure-u-12-24 pure-u-sm-8-24 pure-u-md-6-24 collections__box-col">${mass}</div>`  
                                }
                              }
                              
                          }
                      }
                    });  
                    if(alax == ""){  
                      $('.main-grid-wrapper').html('<div class="no-product-mathc-collection">Sorry, no products matched your selection</div>');
                     }else{
                      $('.main-grid-wrapper').html(alax);
                      $( ".collections__box-col" ).each(function( index ) {
                        $(this).find('.product-metafield-wrapper').remove();
                       });
                     }                                                                
                     $('.tag_filter_count').html('<span>'+tag_val.length+'</span>')
                }
              })
        }
        else{
          
          if ($('#collection-search').val().length === 0) {
            $.ajax({
              type: 'GET',
              url: '/collections/'+collection_search_handle+'?view=ch-collection',
              dataType: 'html',
              success: function(data) { 
                var markup =$(data).find('.main-grid-wrapper').html();                       
                  $('.main-grid-wrapper').html(markup);         
              }
            })
          }else{
            var test1 = $("#collection-search").val();
            if(test1.length > 0) {    
            $.ajax({
              type: 'GET',
              url: '/collections/'+collection_search_handle+'?view=ch-all-product-search',
              dataType: 'html',
              success: function(data) {                 
                var markup1 =$(data).find('.main-grid-wrapper .collections__box-col');                 
                var value = test1.toLowerCase();
                var alax = "";
                let prof = "";
                     markup1.each(function(i,v) {                     
                       prof = this;
                     if(($(this).find('.card__heading').text().toLowerCase().includes($("#collection-search").val().toLowerCase()) ) || ($(this).find('.product-description-wrapper').text().toLowerCase().includes($("#collection-search").val().toLowerCase())) || ($(this).find('.product-metafield-wrapper').text().toLowerCase().includes($("#collection-search").val().toLowerCase()))){                            
                         let mass = $(prof).html()
                         alax += `<div class="pure-u-12-24 pure-u-sm-8-24 pure-u-md-6-24 collections__box-col
                         ">${mass}</div>`
                     }
                  });          
                  if(alax == ""){  
                    $('.main-grid-wrapper').html('<div class="no-product-mathc-collection">Sorry, no products matched your selection</div>');
                   }else{
                    $('.main-grid-wrapper').html(alax);
                    $( ".collections__box-col" ).each(function( index ) {
                      $(this).find('.product-metafield-wrapper').remove();
                     });
                   }         
              }
            })
            }
          }
          setTimeout(function() {
          $('.tag_filter_count').html('');
          }, 500);
        }
});

}


 // search filter in collection page code end here 


//   collection page open popup while click on product code start here

$(document.body).on('click', '.open-product-poup.js-productDetail-modalBtn' ,function(){
    var selected_product_handle = $(this).attr('data-product-handle');
    $.ajax({
      type: 'GET',
      url: '/products/'+selected_product_handle+'?view=ch-product',
      dataType: 'html',
      success: function(data) {         
         var prs =$(data).find('.current-product-details').html();                       
         $('.modal-body .current-product-details').html(prs);

        if($('.product-detail__content--desktop').find('.jdgm-prev-badge__text').length){
        let reviewString = $('.product-detail__content--desktop').find('.jdgm-prev-badge__text').text();        
        reviewString = reviewString.split(" ")[1]
        if(reviewString.includes("No")){
          var str2_desktop = 'Keine Bewertungen'
        }else{
          var str2_desktop = reviewString +' Bewertungen'
        }                
        $('.product-detail__content--desktop').find('.jdgm-prev-badge__text').text(str2_desktop)
        }

        if($('.product-detail__content--mobile').find('.jdgm-prev-badge__text').length){
        let reviewString_mobile = $('.product-detail__content--mobile').find('.jdgm-prev-badge__text').text();        
        reviewString_mobile = reviewString_mobile.split(" ")[1]
        if(reviewString_mobile.includes("No")){
          var str2_mobile = 'Keine Bewertungen'
        }else{
          var str2_mobile = reviewString_mobile +' Bewertungen'
        }                   
        $('.product-detail__content--mobile').find('.jdgm-prev-badge__text').text(str2_mobile)
        }
       
        
         var reciew_button_url = '/products/'+selected_product_handle+'?review-open-form'
         setTimeout(function() {
          
          $("#product-datail-modal .product-detail .jdgm-preview-badge").wrap('<a href="'+ reciew_button_url +'"></a>');
         $('.product-detail__valuation').html('<a href="'+ reciew_button_url +'" class="btn btn--quaternary btn--small">Jetzt bewerten</a>');    
         },200);
        //  Accordian in product modal js start

         if(document.querySelector('#js-product-detail-accordian')) {
          var productDetailAccordion = new Accordion({
            element: "#js-product-detail-accordian",
            multipleTab: true
          });
        }

        //  Accordian in product modal js start
  
        // Open Product Modal js start 

        new Modal({el: document.getElementById('product-datail-modal')}).show();
        
        // Open Product Modal js End 
        
        
        // Product slider in product modal js start
        
        if(document.querySelector('.js-product-detail-slider')) {
      
          var productCarousel = document.querySelector('.js-product-detail-slider');
          
          var productCells = productCarousel.querySelectorAll('.js-product-detail-slider-item');
          
          // var productHasMultipleCells = productCells & productCells.length > 1;
      
          var productHasMultipleCells = productCells.length > 1;
      
          // init Flickity if mulitple cells
            if ( productHasMultipleCells) {
              new Flickity ( productCarousel, {
                pageDots: true,
                prevNextButtons: false,
                watchCSS: true
              });
            }
            else {
              new Flickity ( productCarousel, {
                pageDots: false,
                prevNextButtons: false,
                watchCSS: true
              });
            }
        }

        // Product slider in product modal js End

        
          // About Product modal open & close JS start

          const modalTriggers = document.querySelectorAll('.js-modal-trigger-btn');
          const modalCloseTrigger = document.querySelector('.js-modal-close-trigger-btn');
          const bodyBlackout = document.querySelector('.js-modal-overlay');

          modalTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
              const { popupTrigger } = trigger.dataset;
              const popupModal = document.querySelector(`[data-popup-modal="${popupTrigger}"]`);
              

              popupModal.classList.add('open');
              // console.log(popupModal);
              bodyBlackout.classList.add('open')
              
              popupModal.querySelector('.js-modal-close-trigger-btn').addEventListener('click', () => {
                popupModal.classList.remove('open');
                bodyBlackout.classList.remove('open')
              });
              
              bodyBlackout.addEventListener('click', () => {
                // TODO: Turn into a function to close modal
                popupModal.classList.remove('open');
                bodyBlackout.classList.remove('open')
              });
            })
          })
          


          // About Product modal open & close JS end




          // Remove class in product modal slider Js start

          if(document.querySelector('#product-datail-modal .js-product-detail-slider')) {
            if(document.querySelector('#product-datail-modal .js-product-detail-slider').classList.contains('product-detail__slider--product')) {
              document.querySelector('#product-datail-modal .js-product-detail-slider').classList.remove('product-detail__slider--product');
            }
          }

          // Remove class in product modal slider Js End

      }
    });
})

//   collection page open popup while click on product code end here

// product page review tab default open code start here

$(document).ready(function(){
  let url = window.location.href;
if(url.includes('?review-open-form')){
  setTimeout(function() {    
 $('.review-accordian .accordion__heading').trigger('click');
 $(".review-accordian .accordion__content").css({"height":"unset", "backgrount":"red"});
 $('html, body').animate({
  scrollTop: $(".review-accordian").offset().top - 100
}, 1000);
}, 1000);
}  
})

$(document).ready(function(){
$(".product-detail--product .jdgm-preview-badge").click(function(){ 
  setTimeout(function() {    
 $('.review-accordian .accordion__heading').trigger('click');
 $(".review-accordian .accordion__content").css({"height":"unset", "backgrount":"red"});
}, 500);
})
})
// product page review tab default open code end here



// Principle Read more start

// $(document).ready(function() {
//   (function() {
//     var showChar = 600;
//     var ellipsestext = "...";

//     $(".js-principles-toggle-content").each(function() {
//       var content = $(this).html();
//       if (content.length > showChar) {
//         var c = content.substr(0, showChar);
//         var h = content;
//         var html =
//           '<div class="truncate-text" style="display:block">' +
//           c +
//           '<span class="moreellipses">' +
//           /* ellipsestext  + */
//           '<span class="principles__toggle-btn js-principles-toggle-btn moreless more"><svg xmlns="http://www.w3.org/2000/svg" width="40.189" height="19.186" viewBox="0 0 40.189 19.186"><path id="Path_4105" data-name="Path 4105" d="M599.581,6776.256l16.391,10.779,14.044-10.779" transform="translate(634.923 6790.534) rotate(180)" fill="none" stroke="#e39f8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="7"></path></svg></span></span></span></div><div class="truncate-text" style="display:none">' +
//           h +
//           '<span class="principles__toggle-btn js-principles-toggle-btn moreless less active"><svg xmlns="http://www.w3.org/2000/svg" width="40.189" height="19.186" viewBox="0 0 40.189 19.186"><path id="Path_4105" data-name="Path 4105" d="M599.581,6776.256l16.391,10.779,14.044-10.779" transform="translate(634.923 6790.534) rotate(180)" fill="none" stroke="#e39f8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="7"/></svg></span></span></div>';

//         $(this).html(html);
//       }
//     });

//     $(".moreless").click(function() {
//       var thisEl = $(this);
//       var cT = thisEl.closest(".truncate-text");
//       var tX = ".truncate-text";

//       if (thisEl.hasClass("less")) {
//         cT.prev(tX).toggle();
//         cT.slideToggle();
//       } else {
//         cT.toggle();
//         cT.next(tX).fadeToggle();
//       }
//       return false;
//     });
//     /* end iffe */
//   })();

//   /* end ready */
// });


// Principle Read more end

// code start for hide trushbadge while scroll in desktop 

$(window).scroll(function(){
  if ($(this).scrollTop() > 50) {
     $('#minimized-trustbadge-98e3dadd90eb493088abdc5597a70810').addClass('trustbadge-display');
  } else {
     $('#minimized-trustbadge-98e3dadd90eb493088abdc5597a70810').removeClass('trustbadge-display');
  }
});

// code end for hide trushbadge while scroll in desktop 

// delivery date picker in configurator code start here

var new_date = new Date();
let current_dayNo = new_date.getDay();
let minDate = ""
let day1 = ""
var hour_dd = new_date.getHours();
// console.log('hours ='+hour_dd);
if ( current_dayNo > 0 ){
  if( current_dayNo == 1){
    if (hour_dd <= 9 ){
      minDate = 0;
    }else{       
      minDate = 7;
    }
  }else{
      minDate = 7;
  }
}else{
   minDate = 0;
}

$.datepicker.regional["de"] = {
  closeText: "Schließen",
	prevText: "Zurück",
	nextText: "Vor",
	currentText: "Heute",
	monthNames: [ "Januar", "Februar", "März", "April", "Mai", "Juni",
	"Juli", "August", "September", "Oktober", "November", "Dezember" ],
	monthNamesShort: [ "Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
	"Jul", "Aug", "Sep", "Okt", "Nov", "Dez" ],
	dayNames: [ "Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag" ],
	dayNamesShort: [ "So", "Mo", "Di", "Mi", "Do", "Fr", "Sa" ],
	dayNamesMin: [ "So", "Mo", "Di", "Mi", "Do", "Fr", "Sa" ],
	weekHeader: "KW",
	dateFormat: "dd.mm.yy",
	firstDay: 1,
	isRTL: false,
	showMonthAfterYear: false,
	yearSuffix: ""
};
$.datepicker.setDefaults($.datepicker.regional["de"]);

$(".delivery-summary__date-input").datepicker({
  beforeShowDay: function(date) {   
      return [date.getDay() == 5];
  },
  minDate: minDate,
  dateFormat: 'dd.mm.yy',
  firstDay: 1
});

var $datePicker = $(".delivery-summary__date-input");

if ($datePicker.datepicker("getDate") === null) {

  var today = new Date(),
  carr_hour = today.getHours(),
  todayDay = today.getDay();

  if(todayDay == 0){
      day1 = 5;
  }else if(todayDay == 1){
    if(carr_hour <= 9){
      day1 = 4; 
    }else
    {
        day1 = 11; 
    }        
  }else if(todayDay == 2){
      day1 = 10;
  }else if(todayDay == 3){
      day1 = 9;
  }else if(todayDay == 4){
      day1 = 8;
  }else if(todayDay == 5){
      day1 = 7;
  }else if(todayDay == 6){
      day1 = 6;
  }

var nextDay = new Date(today.setDate(today.getDate() + day1));

      // console.log(day1);  
      // console.log(carr_hour);

      var new_month = nextDay.getMonth() + 1
      if(new_month < 10 ){
        var dlf = "0"+new_month
      }else{
        var dlf = new_month
      }

      var newd_day = nextDay.getDate()
      if(newd_day < 10 ){
        var hdf = "0"+newd_day
      }else{
        var hdf = newd_day
      }

      $datePicker.val(hdf + '.' + dlf + '.' + nextDay.getFullYear());

}

// console.log(today)
// console.log(day)

// delivery date picker in configurator code end here


// parent login popup code start here

$(".parent_login").validate({
  ignore: ":hidden",
  rules: { 
    parent_email:
          {
            required: true,
            email: true,
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          }
        },
  messages: {
    parent_email:
          {
            required: "Bitte gültige Emailadresse angeben",
            email: "Bitte gültige Emailadresse angeben",
            pattern: "Bitte geben Sie eine gültige Emailadresse ein"
          }
        },
    errorPlacement: function(error, element) {
      if (element.attr("name") === "parent_email") {
        error.appendTo(element.closest(".form__row").find(".e-mail-error"));
      }
    }
    
}) 

$(document).on('click', '.parent_login_btn', function(event) {
  event.preventDefault(); 

  if($(".parent_login").valid()){

    var email = $('#ParentEmail').val();
    console.log(email);

    $.ajax({
      url: "https://checkout.chinuki.de/parent/login/page/",
      method: "POST",
      dataType: "JSON",
      data: { parent_email : email },
      success: function(response){
         if(response.status == true && response.token != ''){
            console.log(response.message);
            console.log(response.token);
            window.location.href = 'https://checkout.chinuki.de/parent/otp/'+response.token;
         }else{
            console.log(response.message);
            $('.parent_login .e-mail-error').html(response.message);
         }
      },
      error: function(){
        console.log('OTP not sent');
      }
    })

  }
})

$(document).on('change focus', 'input[name=parent_email]', function(){
  console.log('Input focused or changed');
    $('.e-mail-error').text('');
})

// parent login popup code end here